export const STAGES = [
  { id: 'nuovo', label: 'Nuovo', color: '#94a3b8' },
  { id: 'contattato', label: 'Contattato', color: '#3b82f6' },
  { id: 'demo', label: 'Demo fissata', color: '#a855f7' },
  { id: 'trattativa', label: 'Trattativa', color: '#f59e0b' },
  { id: 'vinto', label: 'Vinto', color: '#10b981' },
  { id: 'perso', label: 'Perso', color: '#ef4444' }
];

export const ACTIVITY_TYPES = ['call', 'whatsapp', 'email', 'demo', 'meeting'];
export const ACTIVITY_LABELS = {
  call: 'Chiamata', whatsapp: 'WhatsApp', email: 'Email', demo: 'Demo', meeting: 'Incontro'
};
export const OUTCOMES = ['Da contattare', 'Non risponde', 'Interessato', 'Da richiamare', 'Non interessato', 'Demo fissata', 'Firmato'];
export const PRIORITIES = ['alta', 'media', 'bassa'];